import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";
import Navbarside from "../Navbarside";
import { deleteayurvedaplans, getayurvedaplans } from "../../store/slices/ayurvedaplan";
import Footer from "../footer";
import { Link, useNavigate } from "react-router-dom";
import { API_PATHS } from "../../utils/constants/api.constants";

const LiveWellPlans = () => {
  const dispatch = useDispatch();
  const [plans, setPlans] = useState([]);
  const [conditions, setConditions] = useState([]);

  React.useEffect(() => {
    axios.get(API_PATHS.getayurvedaconditions).then((response) => {
      setConditions(response.data.data);
    });
    dispatch(getayurvedaplans())
      .unwrap()
      .then((data) => {
        setPlans(data.user.data);
      })
      .catch(({ message }) => {
        // alert(message);
      });
  }, [dispatch]);

  const Delete = async function (id) {
    localStorage.setItem("id", id);
    dispatch(deleteayurvedaplans())
      .unwrap()
      .then(() => {
        window.location.reload(false);
      })
      .catch(({ message }) => {
        alert(message);
      });

    console.log(id);
  };

  const deleteData = (id) => {
    confirmAlert({
      title: "Want to delete?",
      message: "Are you sure you want to delete?",
      buttons: [
        {
          label: "Yes",
          onClick: () => Delete(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  return (
    <div>
      <body data-col="2-columns" className=" 2-columns ">
        <Navbarside />

        <div className="container-fluid pb-5 response-cover">
          <div className="row">
            <div className="col-lg-2 col-md-4" />
            <div className="col-lg-10 col-md-8">
              <div className="container-fluid pt-5">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="card-title-wrap bar-success">
                          <h4 className="card-title">
                            Ayurveda Plans &nbsp; &nbsp;
                            <Link
                              to="/HealthCare/AddAyurvedaPlan"
                              className="btn btn-primary"
                            >
                              <i className="fa fa-plus"></i> Add
                            </Link>
                          </h4>
                        </div>
                      </div>
                      <div className="card-body collapse show">
                        <div className="card-block card-dashboard table-responsive">
                          <table className="table table-striped table-bordered zero-configuration">
                            <thead>
                              <tr>
                                <th>Condition</th>
                                <th>Plan Name</th>
                                <th>Image</th>
                                <th>Price</th>
                                <th>Validity</th>
                                <th>Action</th>
                              </tr>
                            </thead>

                            <tbody>
                              {plans.map((e, index) => (
                                <tr>
                                  <td>{conditions?.find((condition) => condition._id === e.conditionId)?.name}</td>
                                  <td>{e.name}</td>
                                  <td>
                                    <img
                                      src={e.mediaLink}
                                      alt="plans"
                                      style={{
                                        borderRadius: "10px",
                                        height: "60px",
                                        width: "60px",
                                      }}
                                    />
                                  </td>
                                  <td>{e.price}</td>
                                  <td>{e.validityInDays}</td>
                                  <td>
                                    <Link
                                      to={`/HealthCare/EditAyurvedaPlan/${e._id ? e._id : null
                                        }`}
                                      className="btn btn-primary"
                                      style={{
                                        height: "25px",
                                        padding: "0 10px",
                                      }}
                                    >
                                      Edit
                                    </Link>{" "}
                                    &nbsp;
                                    <button
                                      onClick={() => deleteData(e._id)}
                                      className="btn btn-warning"
                                      style={{
                                        height: "25px",
                                        padding: "0 10px",
                                      }}
                                    >
                                      Delete
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </body>
    </div>
  );
};

export default LiveWellPlans;
